export default "__VITE_ASSET__DxYnAtN8__"